import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useAllProjectsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.AllProjectsPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runAllProjectsPageQueryV1: result.run,
		modelAllProjectsPageQueryV1: result.model,
	}
}

export function useFinishedProjectsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.FinishedProjectsPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runFinishedProjectsPageQueryV1: result.run,
		modelFinishedProjectsPageQueryV1: result.model,
	}
}

export function useProjectPhaseDefinitionsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.ProjectPhaseDefinitionsPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runProjectPhaseDefinitionsPageQueryV1: result.run,
		modelProjectPhaseDefinitionsPageQueryV1: result.model,
	}
}

export function useProposedProjectsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.ProposedProjectsPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runProposedProjectsPageQueryV1: result.run,
		modelProposedProjectsPageQueryV1: result.model,
	}
}

export function useScheduledProjectsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.ScheduledProjectsPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runScheduledProjectsPageQueryV1: result.run,
		modelScheduledProjectsPageQueryV1: result.model,
	}
}

export function useStartedProjectsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.StartedProjectsPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runStartedProjectsPageQueryV1: result.run,
		modelStartedProjectsPageQueryV1: result.model,
	}
}

export function useStrategyByWorkspaceIdQueryV1(workspaceId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const result = {
		workspaceId: _workspaceId,
		...useQuery(() => new q.StrategyByWorkspaceIdQueryV1(_workspaceId.value))
	}
	return {
		...result,
		runStrategyByWorkspaceIdQueryV1: result.run,
		modelStrategyByWorkspaceIdQueryV1: result.model,
	}
}

export function useStrategyFixPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.StrategyFixPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runStrategyFixPageQueryV1: result.run,
		modelStrategyFixPageQueryV1: result.model,
	}
}

export function useStrategySettingsQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.StrategySettingsQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runStrategySettingsQueryV1: result.run,
		modelStrategySettingsQueryV1: result.model,
	}
}

